
function LicenseEdit() {
    /// <summary>
    /// This object provides js functions for the Widget.License.Edit.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 10.7.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 10.7.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}

LicenseEdit.prototype = new vcTemplate();

LicenseEdit.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
     
        me.visual.find("#div-btn-save").off("click").on("click", function () { me.save(); }).button();
    return true;
    } catch (ex) { me.writeError('init', ex); return false }
}


LicenseEdit.prototype.save = function () {
    /// <summary>
    ///  This function sends the save request. 
    /// </summary>
    var me = this;
    var param = {}
    var val;
    try {
        if (me.error) { return false;}
       
        if (me.visual.find("#txt-licensee").val().length === 0) {
            alert("Licensee missing!");
            return false;
        }
        val = me.visual.find("#txt-maximum").val();
        if (val.length === 0) {
            alert("Volume missing!");
            return false;
        }

        if (val.indexOf(",") >=0) {
            alert("Volume no Integer!");
            return false;
        }
      
        if ((validateNumeric(val) === false || isNaN(parseInt(val)))) {
            alert("Volume no number!");
            return false;
        }

        param.licensee = me.visual.find("#txt-licensee").val();
        param.maximum = parseInt(me.visual.find("#txt-maximum").val(), 10);

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       function (result) {
           if (result === false) { alert(me.resources.err_saveData); return false; }
           if (result === null) { alert(me.resources.err_saveData); return false; }
          
           if (result === true) {
               me.visual.find("#div-new-license").hide();
               me.visual.find("#div-done").show();
               me.visual.find("#div-btn-save").hide();
           }
           return true;
       });

        return true;
    } catch (ex) { me.writeError('save', ex); return false }

}


LicenseEdit.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#div-new-license").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


